<script>
  /* global Global */
  export let value;

  const projectStyle = Global.project.style;
</script>

<div class='live-state' class:live-state-old={projectStyle === 'old' || projectStyle === 'sharp'}>
  <div class='live-state-ball'>
    <div class='live-state-ball-label'> B </div>

    <div class='live-state-ball-indicator' class:live-state-ball-indicator-active={value.balls >= 1}/>
    <div class='live-state-ball-indicator' class:live-state-ball-indicator-active={value.balls >= 2}/>
    <div class='live-state-ball-indicator' class:live-state-ball-indicator-active={value.balls >= 3}/>
  </div>

  <div class='live-state-strike'>
    <div class='live-state-strike-label'> S </div>

    <div class='live-state-strike-indicator' class:live-state-strike-indicator-active={value.strikes >= 1}/>
    <div class='live-state-strike-indicator' class:live-state-strike-indicator-active={value.strikes >= 2}/>
  </div>

  <div class='live-state-out'>
    <div class='live-state-out-label'> O </div>

    <div class='live-state-out-indicator' class:live-state-out-indicator-active={value.outs >= 1}/>
    <div class='live-state-out-indicator' class:live-state-out-indicator-active={value.outs >= 2}/>
  </div>
</div>

<style>
  .live-state {
    display: flex;
    flex-direction: column;
  }

  .live-state-ball,
  .live-state-strike,
  .live-state-out {
    display: flex;

    height: 20px;
  }

  .live-state-ball-label,
  .live-state-strike-label,
  .live-state-out-label {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    font-size: 14px;
    font-weight: 550;
  }

  .live-state-ball-indicator,
  .live-state-strike-indicator,
  .live-state-out-indicator {
    width: 15px;
    height: 15px;

    margin: 2.5px;

    border-radius: 50%;

    background: var(--grey-3);
  }

  .live-state-ball-indicator-active {
    background: linear-gradient(135deg, var(--green), var(--dark-green));
  }

  .live-state-old .live-state-ball-indicator-active {
    background: var(--green);
  }

  .live-state-strike-indicator-active {
    background: linear-gradient(135deg, var(--yellow), var(--orange));
  }

  .live-state-old .live-state-strike-indicator-active {
    background: var(--yellow);
  }

  .live-state-out-indicator-active {
    background: linear-gradient(135deg, var(--red), var(--dark-red));
  }

  .live-state-old .live-state-out-indicator-active {
    background: var(--red);
  }

  :global(body.dark) .live-state-ball-indicator,
  :global(body.dark) .live-state-strike-indicator,
  :global(body.dark) .live-state-out-indicator {
    background: var(--grey-7);
  }

  :global(body.dark) .live-state-ball-indicator-active {
    background: linear-gradient(135deg, var(--green-dark), var(--dark-green-dark));
  }

  :global(body.dark) .live-state-old .live-state-ball-indicator-active {
    background: var(--green-dark);
  }

  :global(body.dark) .live-state-strike-indicator-active {
    background: linear-gradient(135deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .live-state-old .live-state-strike-indicator-active {
    background: var(--yellow-dark);
  }

  :global(body.dark) .live-state-out-indicator-active {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .live-state-old .live-state-out-indicator-active {
    background: var(--red-dark);
  }
</style>
